/**
 * comercialGapsBuilder (S2) — grupos de venda, links de captação, processo seletivo.
 *
 * @since S2 (gaps SA→AVA)
 */
import type { $Fetch } from 'ofetch';

import {
  HttpGrupoVendaGateway, HttpLinkCaptacaoGateway, HttpProcessoSeletivoGateway,
} from '@/infrastructure/http/HttpComercialGapsGateways';
import {
  ListGruposVenda, CreateGrupoVenda, UpdateGrupoVenda, RemoveGrupoVenda,
  ListLinksCaptacao, CreateLinkCaptacao, UpdateLinkCaptacao, RemoveLinkCaptacao,
  ListProcessosSeletivos, CreateProcessoSeletivo, UpdateProcessoSeletivo,
  AbrirProcessoSeletivo, EncerrarProcessoSeletivo, RemoveProcessoSeletivo,
  ListInscricoes, CriarInscricao, AprovarInscricao, ReprovarInscricao,
} from '@/application/usecase/ComercialGapsUseCaseImpl';

export function buildComercialGapsSlice(httpClient: $Fetch) {
  const grupoGateway = new HttpGrupoVendaGateway(httpClient);
  const linkGateway = new HttpLinkCaptacaoGateway(httpClient);
  const psGateway = new HttpProcessoSeletivoGateway(httpClient);

  const useCases = {
    listGruposVenda: new ListGruposVenda(grupoGateway),
    createGrupoVenda: new CreateGrupoVenda(grupoGateway),
    updateGrupoVenda: new UpdateGrupoVenda(grupoGateway),
    removeGrupoVenda: new RemoveGrupoVenda(grupoGateway),
    listLinksCaptacao: new ListLinksCaptacao(linkGateway),
    createLinkCaptacao: new CreateLinkCaptacao(linkGateway),
    updateLinkCaptacao: new UpdateLinkCaptacao(linkGateway),
    removeLinkCaptacao: new RemoveLinkCaptacao(linkGateway),
    listProcessosSeletivos: new ListProcessosSeletivos(psGateway),
    createProcessoSeletivo: new CreateProcessoSeletivo(psGateway),
    updateProcessoSeletivo: new UpdateProcessoSeletivo(psGateway),
    abrirProcessoSeletivo: new AbrirProcessoSeletivo(psGateway),
    encerrarProcessoSeletivo: new EncerrarProcessoSeletivo(psGateway),
    removeProcessoSeletivo: new RemoveProcessoSeletivo(psGateway),
    listInscricoes: new ListInscricoes(psGateway),
    criarInscricao: new CriarInscricao(psGateway),
    aprovarInscricao: new AprovarInscricao(psGateway),
    reprovarInscricao: new ReprovarInscricao(psGateway),
  };

  return { useCases };
}
